export interface VitalRangeLimits {
  min_value: number | null;
  max_value: number | null;
  min_value_secondary: number | null;
  max_value_secondary: number | null;
}

/**
 * Checks whether a vital sign measurement is outside the acceptable range.
 * Returns true if ANY value (primary or secondary) falls outside its limits.
 * Returns false if no range is provided or all limits are null.
 */
export function checkVitalAlert(
  value: number,
  valueSecondary: number | null,
  range: VitalRangeLimits | undefined | null
): boolean {
  if (!range) return false;

  if (range.min_value != null && value < range.min_value) return true;
  if (range.max_value != null && value > range.max_value) return true;

  if (valueSecondary != null) {
    if (range.min_value_secondary != null && valueSecondary < range.min_value_secondary) return true;
    if (range.max_value_secondary != null && valueSecondary > range.max_value_secondary) return true;
  }

  return false;
}
